import { IntlShape } from 'react-intl';

export const getAuthorizeError = (intl: IntlShape): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: intl.formatMessage({ id: 'pages:preAuthDetail:error:authorize:message' }),
		TITLE: intl.formatMessage({ id: 'pages:preAuthDetail:error:authorize:title' }),
	};
};

export const getInvalidCardError = (intl: IntlShape): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: intl.formatMessage({ id: 'pages:preAuthDetail:error:invalidCard:message' }),
		TITLE: intl.formatMessage({ id: 'pages:preAuthDetail:error:invalidCard:title' }),
	};
};

export const getTimeoutError = (intl: IntlShape): { MESSAGE: string; TITLE: string } => {
	return {
		MESSAGE: intl.formatMessage({ id: 'pages:preAuthDetail:error:timeout:message' }),
		TITLE: intl.formatMessage({ id: 'pages:preAuthDetail:error:timeout:title' }),
	};
};
